var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"indexPage"}},[_c('div',{staticClass:"app-container"},[_c('router-view')],1),_c('div',{staticClass:"footer"},[_c('p',{staticClass:"copyright"},[_vm._v("Copyright © ️2020  好未来版权所有  北京彼芯托育服务有限公司")]),_c('p',{staticClass:"backup",on:{"click":_vm.goDetail}},[_vm._v("京ICP备18011062号-1 晋公网安备14102102000119号")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }